import { fromIso8601Date, toLocaleTextAsDate } from "@/shared/lib/datetime";
import { BaseKeyValue } from "@/shared/ui/BaseKeyValue";
import { Grid2, Typography } from "@mui/material";
import type { FreightMatching } from "@x-mile/api-contract";

export type OfferCargoScheduleInfoProps = {
  draftOfferCargo: Pick<
    FreightMatching.schemas.OfferCargo,
    "loadingOn" | "unloadingOn"
  >;
};

export const OfferCargoScheduleInfo = ({
  draftOfferCargo,
}: OfferCargoScheduleInfoProps) => {
  const { loadingOn, unloadingOn } = draftOfferCargo;

  return (
    <>
      <Typography
        variant="body1"
        fontWeight={700}
        mb={1}
        sx={{
          "::before": {
            content: '"■"',
            fontSize: "150%",
            marginRight: "2px",
          },
        }}
      >
        配送スケジュール
      </Typography>
      <Grid2 container>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <BaseKeyValue keyLabel="積日">
            {toLocaleTextAsDate(fromIso8601Date(loadingOn))}
          </BaseKeyValue>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <BaseKeyValue keyLabel="卸日">
            {toLocaleTextAsDate(fromIso8601Date(unloadingOn))}
          </BaseKeyValue>
        </Grid2>
      </Grid2>
    </>
  );
};
